import { render, staticRenderFns } from "./dialog-set-price.vue?vue&type=template&id=6e96bd38&scoped=true&"
import script from "./dialog-set-price.vue?vue&type=script&lang=js&"
export * from "./dialog-set-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96bd38",
  null
  
)

export default component.exports